import CommonService from './common.service'

class ReportService extends CommonService {
  async getStatics() {
    return await this.get('/reports/stats')
  }

  async getDayWiseOrders(params: { start_date: string; end_date: string }) {
    return await this.get(
      `/reports/orders-daywise?start_date=${params.start_date}&end_date=${params.end_date}`
    )
  }

  async getMonthWiseOrders(params: { start_date: string; end_date: string }) {
    return await this.get(
      `/reports/orders-monthwise?start_date=${params.start_date}&end_date=${params.end_date}`
    )
  }
  async getStateWiseOrders(params: { start_date: string; end_date: string }) {
    return await this.get(
      `/reports/orders-statewise?start_date=${params.start_date}&end_date=${params.end_date}`
    )
  }
}

export const reportService = new ReportService()
